import React, {Component} from 'react';
import {Navbar, Nav, NavItem, NavbarToggler, Collapse} from "reactstrap";
import PropTypes from "prop-types";
import ContactButton from "../../../Footer/components/ContactButton";
import PauseButton from "../../../Footer/components/PauseButton";

class Navigation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      collapsed: true
    };

    this.toggleNavbar = this.toggleNavbar.bind(this);
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  render() {
    const {response, pages} = this.props;

    const shouldRenderPause = !response.isRegisteredUser && !_.isEmpty(pages) && response.survey.pauseEnable;
    const shouldRenderContact = response.survey.contact;

    if (!shouldRenderPause && !shouldRenderContact) {
      return null;
    }

    return null;
  }
}

Navigation.propTypes = {
  pages: PropTypes.array.isRequired,
  response: PropTypes.object.isRequired
};

export default Navigation;